import styled, { css } from 'styled-components';
import { lightGrey1Color, lightGrey3Color } from 'js/config/style';

export const size = 2.25;
const backgroundColor = lightGrey1Color;

const hoverStyle = css`
  color: ${lightGrey3Color.darken()};
  background: ${backgroundColor.darken(0.25)};
  .pencil,
  .ellipsis {
    fill: ${lightGrey3Color.darken()};
  }
`;

export default styled.div`
  grid-area: ${({ area }) => area};
  height: ${size}rem;
  min-width: ${size}rem;
  line-height: ${size}rem;
  border-radius: ${size}rem;
  background: ${backgroundColor};
  cursor: pointer;
  color: ${lightGrey3Color};
  user-select: none;
  display: grid;
  grid-column-gap: 0.5rem;
  grid-auto-flow: column;

  &:hover {
    ${hoverStyle}
  }

  &:active {
    ${hoverStyle}
    background: ${backgroundColor.darken(0.5)};
  }
`;
